import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formatMoney } from '../../../../utils/numbers';

class OffersV4Slider extends Component {
    static propTypes = {
        minOffer: PropTypes.number.isRequired,
        maxOffer: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        disabled: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            showTooltip: false,
        };
    }

    handleChange = (e) => {
        this.props.onChange(Number(e.target.value));
    };

    handleMouseDown = () => {
        this.setState({ showTooltip: true });
    };

    handleMouseUp = () => {
        this.setState({ showTooltip: false });
    };

    handleMouseEnter = () => {
        this.setState({ showTooltip: true });
    };

    handleMouseLeave = () => {
        this.setState({ showTooltip: false });
    };

    getFilledPercent() {
        const { minOffer, maxOffer, value } = this.props;
        return ((value - minOffer) / (maxOffer - minOffer)) * 100;
    }

    render() {
        const { minOffer, maxOffer, value, disabled } = this.props;
        const { showTooltip } = this.state;
        const filledPercent = this.getFilledPercent();

        return (
            <div className="offers-v4-slider">
                <div className="offers-v4-slider__track-container">
                    {showTooltip && (
                        <div
                            className="offers-v4-slider__tooltip"
                            style={{ left: `calc(${filledPercent}% + ${10 - (filledPercent * 0.2)}px)` }}
                        >
                            {formatMoney(value)}
                        </div>
                    )}
                    <input
                        id="offers-v4-slider"
                        type="range"
                        className="offers-v4-slider__input"
                        min={minOffer}
                        max={maxOffer}
                        step={500}
                        value={value}
                        disabled={disabled}
                        onChange={this.handleChange}
                        onMouseDown={this.handleMouseDown}
                        onMouseUp={this.handleMouseUp}
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        onTouchStart={this.handleMouseDown}
                        onTouchEnd={this.handleMouseUp}
                        aria-label="Loan amount"
                        aria-valuetext={formatMoney(value)}
                        style={{ '--filled-percent': `${filledPercent}%` }}
                    />
                </div>
                <div className="offers-v4-slider__labels">
                    <span className="offers-v4-slider__label">{formatMoney(minOffer)}</span>
                    <span className="offers-v4-slider__label">{formatMoney(maxOffer)}</span>
                </div>
            </div>
        );
    }
}

export default OffersV4Slider;
